import { Location } from '@angular/common';
import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router, Scroll } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { DocumentTypeEnterprise } from 'src/app/core/class/DocumentTypeEnterprise';
import { Message } from 'src/app/core/class/message';
import { LotType } from 'src/app/core/constants/lot-type';
import { CommonService } from 'src/app/core/services/common.service';
import { DataService } from 'src/app/core/services/data.service';
import { DocumentTemplateService } from 'src/app/core/services/document-template.service';
import { CustomerService } from 'src/app/core/services/customer.service';
import { ContentType } from 'src/app/core/services/file-utils';
import { NotificationService } from 'src/app/core/services/notification.service';
import { ProcessingService } from 'src/app/core/services/processing.service';
import { TemplateFileService } from 'src/app/core/services/template-file.service';
import { UploadFileComponent } from 'src/app/shared/components/upload-file/upload-file.component';
import { ContractLotService } from "src/app/core/services/contract-lot.service";
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { BreadcrumbsService } from 'src/app/shared/components/breadcrumbs/breadcrumbs.service';
import { repeat, delay } from 'rxjs/operators';

@Component({
  selector: 'app-result-sync-customer',
  templateUrl: './result-sync-customer.component.html',
  styleUrls: ['./result-sync-customer.component.scss']
})
export class ResultSyncCustomerComponent implements OnInit {
  @ViewChild(UploadFileComponent, { read: UploadFileComponent, static: false }) uploadFileComponent;
  processing = {
    percent: 0
  }
  @BlockUI() blockUI: NgBlockUI;
  @HostListener('window:scroll', ['$event']) onKeydownHandler(event: Scroll) {
    this.onTableScroll();
  }
  dataResultSync = {
    startTime: '',
    endTime: '',
    total: '',
    done: '',
    failed: '',
    processing: ''
  }
  lastScrollTop = 0;
  id: string = null;
  bread
  start: number = 0;
  limit: number = 15;
  end: number = this.limit + this.start;
  isLoading = false
  nzData: any[] = [];
  dataSource: any[] = [];
  goFrom = ''
  constructor(private templateFileService: TemplateFileService,
    public commonService: CommonService,
    private dialog: MatDialog,
    private router: Router,
    public notificationService: NotificationService,
    private toast: ToastrService,
    public message: Message,
    private route: ActivatedRoute,
    private customerService: CustomerService,
    public documentTemplateService: DocumentTemplateService,
    public location: Location,
    private breadcrumbsService: BreadcrumbsService,
    public processingService: ProcessingService,
    private dataService: DataService,
    public contractLotService: ContractLotService,
    private toastr: ToastrService,) {
    this.bread = { label: 'breadcrumbs.enterprise_customer', url: 'customers', params: [] };
  }

  handleBreadcrumbs() {
    this.breadcrumbsService.store([
      { label: 'breadcrumbs.home', url: 'analysis-report', params: [] },
      this.bread,
      {
        label: this.message.getMessage("breadcrumbs.result_sync_customer")
      },
    ]);
  }

  ngOnInit() {
    this.blockUI.start('');
    this.route
      .queryParams
      .subscribe(params => {
        this.goFrom = params.goFrom || null
      });
    this.id = this.route.snapshot.params.id;
    this.handleBreadcrumbs();
    if (this.id) {
      let totalCustomerHasResult = 0;
      const getReult = this.customerService.getResultSyncCustomers(this.id).pipe(delay(5000), repeat()).subscribe(res => {
        if (res && res.success) {
          totalCustomerHasResult = res.data.done + res.data.failed
          this.dataResultSync = res.data
          this.dataSource = res.data.details;
          this.processing.percent = (totalCustomerHasResult / res.data.total) * 100
          this.nzData = this.getTableData(this.start, this.end);
          if (this.goFrom != 'notification' && totalCustomerHasResult >= res.data.total) {
            this.toast.success(this.commonService.format(
              this.message.getMessage('result_sync_customers.message.success'), res.data.done, res.data.total))
            getReult.unsubscribe();
          }
          setTimeout(() => {
            this.blockUI.stop();
          }, 500);
        } else {
          this.toast.error(res.message)
          getReult.unsubscribe();
          this.blockUI.stop();
        }
      });
    }

  }

  onTableScroll() {
    let st = window.pageYOffset || document.documentElement.scrollTop;

    // If the user has scrolled within 200px of the bottom, add more data
    const buffer = 200;
    const limit = st - buffer;
    if (limit > this.lastScrollTop || this.lastScrollTop === 0) {
      this.nzData = this.getTableData(this.start, this.end);
      this.updateIndex();
      this.lastScrollTop = limit <= 0 ? 0 : limit;
    }
  }

  getTableData(start, end) {
    return this.dataSource.filter((value, index) => index < end);
  }

  updateIndex() {
    this.end = this.limit + this.end;
  }

  identify(index, item){
    return item.status;
  }

  renderNumber(type: 'total' | 'success' | 'error') {
    if (this.dataSource) {
      switch (type) {
        case 'total':
          return this.dataSource.length;
        case 'error':
          return this.dataSource.filter(item => {
            return item.status === 'ERROR';
          }).length;
        case 'success':
          return this.dataSource.filter(item => {
            return item.status === 'DONE';
          }).length;
      }
    }
  }

  renderStatus(status: string) {
    switch (status) {
      case 'ERROR':
        return this.message.getMessage('result_sync_customers.status.failed');
      case 'PROCESSING':
        return this.message.getMessage('result_sync_customers.status.processing');
      case 'DONE':
        return this.message.getMessage('result_sync_customers.status.done');
      default:
        return '';
    }
  }

  renderStatusColor(status: string): object {
    switch (status) {
      case 'ERROR':
        return { 'color': 'red', 'border': '1px solid red', 'border-radius': '5px' };
      case 'PROCESSING':
        return { 'color': 'blue', 'border': '1px solid blue', 'border-radius': '5px' };
      default:
        return { 'color': 'green', 'border': '1px solid green', 'border-radius': '5px' };
    }
  }

  onClickCancel() {
    this.location.back();
  }

  dateToString(date: Date) {
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();
    let hour = String(date.getHours()).padStart(2, '0');
    let minutes = String(date.getMinutes()).padStart(2, '0');
    let seconds = String(date.getSeconds()).padStart(2, '0');
    return yyyy + mm + dd + hour + minutes + seconds;
  }

}
